/**
 * Splits a text into paragraphs.
 *
 * @param text Input text without formatting.
 * @returns An array of paragraphs.
 */
export const textToParagraphs = (text: string): string[] =>
  text.split(/\n{2,}/);
